<template>
  <div class="container-fluid">
    <div class="container p-0 card_background_effect">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-0">
          <div class="login-form d-flex">
              <form class="sign-in-sign-up-form w-100"
                  ref="form"
                  v-if="companyInfo"
                  :data-url="addUrl"
                  method="post"
                  :class="{ 'loading-opacity': preloader && active !== maxStep }">
              <div class="text-center mb-4">
                <div v-if="companyInfo.logo" class="mb-2">
                  <img :src="companyInfo.logo" alt="Company Logo" class="img-fluid logo" style="max-height: 60px;"/>
                </div>
                <h5 class="fw-bold mb-1" v-if="companyInfo.company_name">{{ companyInfo.company_name }}</h5>

                <p class="mb-1" v-if="companyInfo.address || companyInfo.address_line_1">
                  {{ companyInfo.address || [companyInfo.address_line_1, companyInfo.address_line_2, companyInfo.city, companyInfo.postal_code, companyInfo.country].filter(Boolean).join(', ') }}
                </p>

                <p class="mb-2 small">
                  <span v-if="companyInfo.company_email"><strong>Email:</strong> {{ companyInfo.company_email }}</span>
                  <span v-if="companyInfo.company_phone">
                    <span v-if="companyInfo.company_email"> | </span>
                    <strong>Phone:</strong> {{ companyInfo.company_phone }}
                  </span>
                                <span v-if="companyInfo.comapny_number">
                    <span v-if="companyInfo.company_email || companyInfo.company_phone"> | </span>
                    <strong>Company No:</strong> {{ companyInfo.comapny_number }}
                  </span>
                </p>

                <h6 class="fw-bold text-uppercase mt-3">Job Application Form</h6>
              </div>

              <div v-if="!showCompletedStatus" class="ai-cv-import card mb-4">
                <div class="card-body d-md-flex align-items-center justify-content-between">
                  <div class="pr-md-4">
                    <h6 class="font-weight-bold mb-1">
                      <i class="el-icon-magic-stick mr-1"></i>
                      Autofill from your documents
                    </h6>
                    <p class="text-muted small mb-0">
                      Let AI read your CV and application documents to fill in your details, or enter everything
                      yourself. Existing answers are preserved, and every imported field should be reviewed before
                      you continue.
                    </p>
                  </div>
                  <div class="mt-3 mt-md-0 flex-shrink-0">
                    <el-button
                        type="primary"
                        :loading="aiExtracting"
                        :disabled="aiExtracting"
                        @click.prevent="openFillChoiceModal"
                    >
                      {{ aiExtracting ? 'Reading documents...' : 'Autofill with AI' }}
                    </el-button>
                  </div>
                </div>

                <div v-if="aiImportSummary" class="ai-cv-result border-top px-4 py-3">
                  <strong>{{ aiImportSummary }}</strong>
                  <span class="small text-muted ml-1">No information has been saved yet. Please review every field before continuing.</span>
                  <ul v-if="aiWarnings.length" class="small text-warning mb-0 mt-2 pl-3">
                    <li v-for="(warning, index) in aiWarnings" :key="`ai-warning-${index}`">
                      {{ warning }}
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Choose how to fill the form: AI autofill or manual entry -->
              <el-dialog
                  :visible.sync="fillChoiceModalVisible"
                  :close-on-click-modal="false"
                  :show-close="true"
                  width="640px"
                  custom-class="fill-choice-dialog"
                  append-to-body
                  center
              >
                <div slot="title" class="fill-choice-header text-center">
                  <h5 class="font-weight-bold mb-1">How would you like to fill this form?</h5>
                  <p class="text-muted small mb-0">Choose AI autofill to save time, or fill it in manually.</p>
                </div>

                <div class="row no-gutters fill-choice-options">
                  <div class="col-12 col-md-6 px-2 mb-3 mb-md-0">
                    <button type="button" class="fill-choice-card" :disabled="aiExtracting" @click="chooseAiFill">
                      <i class="el-icon-magic-stick fill-choice-icon"></i>
                      <span class="fill-choice-title">Fill Form by AI</span>
                      <span class="fill-choice-desc">
                        Review the consent, upload your CV and required documents, then let AI fill your details for you.
                      </span>
                    </button>
                  </div>
                  <div class="col-12 col-md-6 px-2">
                    <button type="button" class="fill-choice-card" @click="chooseManualFill">
                      <i class="el-icon-edit-outline fill-choice-icon"></i>
                      <span class="fill-choice-title">Fill Form Manually</span>
                      <span class="fill-choice-desc">
                        Prefer to type it yourself? Enter your details directly in the form below.
                      </span>
                    </button>
                  </div>
                </div>
              </el-dialog>

              <el-dialog
                  :visible.sync="aiConsentModalVisible"
                  :close-on-click-modal="false"
                  :show-close="true"
                  width="560px"
                  custom-class="ai-consent-dialog"
                  append-to-body
              >
                <div slot="title" class="fill-choice-header text-center">
                  <h5 class="font-weight-bold mb-1">Consent for AI Autofill</h5>
                  <p class="text-muted small mb-0">Please read and accept before uploading documents.</p>
                </div>
                <div class="ai-consent-copy">
                  <p>
                    Your uploaded documents will be sent to the AI service only to read the information needed to
                    prefill this application form.
                  </p>
                  <p>
                    After extraction, the uploaded files will be attached to your application record so you do not
                    need to upload them again in the Documents step. You must review and correct all imported fields
                    before submitting.
                  </p>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="aiConsentModalVisible = false">Back</el-button>
                  <el-button type="primary" @click="acceptAiConsent">I Agree & Continue</el-button>
                </span>
              </el-dialog>

              <el-dialog
                  :visible.sync="aiDocumentUploadModalVisible"
                  :close-on-click-modal="false"
                  :show-close="!aiExtracting"
                  width="760px"
                  custom-class="ai-document-upload-dialog"
                  append-to-body
              >
                <div slot="title" class="fill-choice-header text-center">
                  <h5 class="font-weight-bold mb-1">Upload Documents for AI Autofill</h5>
                  <p class="text-muted small mb-0">Upload clear files. The documents will be attached after extraction succeeds.</p>
                </div>

                <div class="alert alert-info py-2">
                  Required: CV. Other documents are optional but improve autofill accuracy.
                </div>

                <label class="ai-driving-toggle">
                  <input type="checkbox" v-model="aiHasDrivingLicense" :disabled="aiExtracting">
                  <span>I have a driving licence and want to upload it now.</span>
                </label>

                <div class="ai-document-list" :key="aiUploadInputKey">
                  <div class="ai-document-row" v-for="document in aiDocumentUploadFields" :key="document.key">
                    <div class="ai-document-meta">
                      <strong>{{ document.label }}</strong>
                      <span>{{ document.help }}</span>
                    </div>
                    <div class="ai-document-control">
                      <input
                          type="file"
                          :accept="document.accept"
                          :disabled="aiExtracting"
                          @change="handleAiDocumentSelection(document.key, $event)"
                      />
                      <small v-if="aiDocuments[document.key]" class="text-success">
                        {{ aiDocuments[document.key].name }}
                      </small>
                    </div>
                  </div>
                </div>

                <div v-if="aiDocumentErrors.length" class="alert alert-warning mt-3 mb-0">
                  <ul class="mb-0 pl-3">
                    <li v-for="error in aiDocumentErrors" :key="error">{{ error }}</li>
                  </ul>
                </div>

                <span slot="footer" class="dialog-footer">
                  <el-button :disabled="aiExtracting" @click="cancelAiDocumentUpload">Cancel</el-button>
                  <el-button type="primary" :loading="aiExtracting" @click="processAiDocuments">
                    {{ aiExtracting ? 'Processing...' : 'Process Documents with AI' }}
                  </el-button>
                </span>
              </el-dialog>



              <div class="row" v-if="!showCompletedStatus">
                <div class="col-sm-1 col-md-2"
                     v-if="isMobile === 'vertical'">
                  <div style="height: auto">
                    <el-steps direction="vertical"
                              :active="active"  @change="handleStepChange" :space="100"
                              :align-center="true" clickable>
                      <el-step title="Basic Information"
                              />
                      <el-step title="Bank A/C Details"
                               />
                      <el-step title="Addresses"
                               />
                      <el-step title="Trainings"
                               />
                      <el-step title="Previous Employment"
                               />
                      <el-step title="SIA Questionnaire"
                              />
                      <el-step title="Upload Documents"
                              />
                      <el-step title="GDPR Notice"
                              />
                    </el-steps>
                  </div>
                </div>
                <div class="col-md-12 scroll-container"
                     v-if="isMobile === 'horizontal'">
                  <div class="scroll-content">
                    <div style="height: auto">
                      <el-steps direction="horizontal"  @change="handleStepChange"
                                :active="active">
                        <el-step title="Basic Information"
                                 @click.native="e => stepClick(e, 0)"/>
                        <el-step title="Bank A/C Details"
                                 @click.native="e => stepClick(e, 1)"/>
                        <el-step title="Addresses"
                                 @click.native="e => stepClick(e, 2)"/>
                        <el-step title="Trainings"
                                 @click.native="e => stepClick(e, 3)"/>
                        <el-step title="Employment History"
                                 @click.native="e => stepClick(e, 4)"/>
                        <el-step title="SIA Questionnaire"
                                 @click.native="e => stepClick(e, 5)"/>
                        <el-step title="Upload Documents"
                                 @click.native="e => stepClick(e, 6)"/>
                        <el-step title="GDPR Notice"
                                 @click.native="e => stepClick(e, 7)"/>
                      </el-steps>
                    </div>
                  </div>
                </div>
                <div :class=" isMobile == 'vertical' ? 'col-sm-11 col-md-10' : 'col-md-12'">
                  <el-form v-if="active === 0">
                    <basic-info
                        :basic_info="basicInfo"
                        :yesOrNoList="yesOrNoList"
                        :isAdmin="false"
                        :restrict-validation="isRestrictedForm"
                        :validation-default="validationDefault"
                        :onSaveBtn="saveBtnHandler"
                        ref="basicInfo"
                        @update:licenses="val => basicInfo.licenses = val"
                    />

                  </el-form>
                  <el-form v-if="active === 1">
                    <payroll-info :payroll_info="payrollInfo"
                                  ref="payrollInfo"
                                  :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === 2">
                    <address-info :address_Info="addressInfo" :dateFormatter="dateFormatter"
                                  :isAdmin="false"
                                  :emailAddress="basicInfo.email"
                                  :onSaveBtn="saveBtnHandler"
                                  :restrict-validation="isRestrictedForm ? !!validationDefault.addressHistory : true"
                                  ref="addressInfo"
                    />
                  </el-form>
                  <el-form v-if="active === 3">
                    <training-info :yesOrNoList="yesOrNoList"
                                   :training_info="trainingInfo"
                                   :dateFormatter="dateFormatter"
                                   :emailAddress="basicInfo.email"
                                   :onSaveBtn="saveBtnHandler"
                                   :isAdmin="false"
                                   ref="trainingInfo"
                    />
                  </el-form>
                  <el-form v-if="active === 4">
                    <candidate-history :candidate_history_info="candidateHistoryInfo"
                                       :emailAddress="basicInfo.email"
                                       :dateFormatter="dateFormatter"
                                       :onSaveBtn="saveBtnHandler"
                                       :isAdmin="false"
                                       :restrict-validation="isRestrictedForm ? !!validationDefault.employmentHistory : true"
                                       ref="candidateHistory"
                    />
                  </el-form>
                  <el-form v-if="active === 5">
                    <sia-info :sia_Info="siaInfo" :isAdmin="false" ref="siaStep"/>
                  </el-form>
                  <el-form v-if="active === 6">
                    <uploaded-documents-info    ref="applicantFiles" :emailAddress="basicInfo.email" :isAdmin="false"/>
                  </el-form>
                  <el-form v-if="active === maxStep">
                    <gdpr-notice-info :gdpr_info="gdprInfo" :companyInfo="companyInfo" :onSaveBtn="saveBtnHandler" ref="gdprInfo" :isAdmin="false"/>
                  </el-form>
<!--                  <el-form >-->
<!--                    <policy-declaration-info :policy_declaration="policyDeclarationInfo"-->
<!--                                             :yesOrNoList="yesOrNoList"-->
<!--                                             :isAdmin="false"/>-->
<!--                  </el-form>-->
                </div>
              </div>
              <template v-if="showCompletedStatus">
                <div class="application-success-container p-4 p-md-5 mt-4">
                  <div class="text-center mb-5">
                    <div class="success-checkmark-wrapper mb-4">
                      <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                      </div>
                    </div>
                    <h2 class="display-5 fw-bold text-success mb-2 animate-up">Success!</h2>
                    <h4 class="fw-bold mb-3 animate-up delay-1">Your Application is Received.</h4>
                  </div>

                  <div class="message-box p-4 rounded-lg bg-light border-0 mb-5 animate-up delay-3">
                    <p class="mb-0 text-center lead-sm">
                      Thank you for your interest in <strong>{{ companyInfo.company_name || configData.company_name || 'our company' }}</strong>. 
                      Your application has been successfully submitted and will be reviewed by our team shortly. 
                      We appreciate the time you took to apply and will be in touch if your qualifications match our requirements.
                    </p>
                  </div>

                  <div class="next-steps-section animate-up delay-4">
                    <h5 class="fw-bold border-bottom pb-3 mb-4 text-uppercase tracking-wider small">What happens next?</h5>
                    
                    <div class="next-step-item d-flex align-items-start mb-4">
                      <div class="step-icon-bg bg-soft-success mr-3">
                        <i class="el-icon-document text-success"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Application Review</h6>
                        <p class="text-muted small mb-0">Our team will carefully review your details and experience.</p>
                      </div>
                    </div>

                    <div class="next-step-item d-flex align-items-start mb-4">
                      <div class="step-icon-bg bg-soft-primary mr-3">
                        <i class="el-icon-user text-primary"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Interview Process</h6>
                        <p class="text-muted small mb-0">Qualified candidates will be invited for an interview to discuss the role further.</p>
                      </div>
                    </div>

                    <div class="next-step-item d-flex align-items-start">
                      <div class="step-icon-bg bg-soft-warning mr-3">
                        <i class="el-icon-finished text-warning"></i>
                      </div>
                      <div>
                        <h6 class="fw-bold mb-1">Final Decision</h6>
                        <p class="text-muted small mb-0">We will notify all applicants of the outcome, regardless of the result.</p>
                      </div>
                    </div>
                  </div>

                  <div class="text-center mt-5 pt-4 animate-up delay-5">
                    <p class="text-secondary small">You can now safely close this window.</p>
                  </div>
                </div>
              </template>

              <div v-if="missingRanges && missingRanges.length" class="alert alert-warning">
                <strong>Incomplete history:</strong>
                <ul>
                  <li v-for="range in missingRanges" :key="missing_from">
                    <span v-if="range.missing_from">
                      Missing from {{ range.missing_from }} to {{ range.missing_to }}
                    </span>

                  </li>
                </ul>
              </div>
              <div v-if="missingDocuments && missingDocuments.length" class="alert alert-warning">
                <strong>Document Required:</strong>
                <ul>
                  <li v-for="document in missingDocuments" :key="document">
                    Missing Documents: {{ document }}
                  </li>
                </ul>
              </div>
              <div class="form-row mt-5 d-flex align-items-center position-sticky" v-if="!showCompletedStatus">
                <div class="p-2">
                  <el-button class="btn btn-primary el-button--default"
                             @click="previous"

                             v-if="this.active > 0">
                    Previous
                  </el-button>
                </div>
                <div class="p-2">
                <el-button class="btn btn-primary el-button--default"
                           @click="next"

                           v-if="this.active < maxStep">
                  Next
                </el-button>
              </div>
                <div class="p-2" v-if="this.active >= 7">
                  <el-button class="btn btn-primary el-button--default"
                             @click="saveBtnHandler(false)">
                    {{ this.active < maxStep ? 'Save' : 'Submit' }}
                  </el-button>
                </div>

              </div>
              <div class="form-row">
                <div class="col-12">
                  <p class="text-center">
                    {{ $t("copyright_text") + configData.company_name }}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

        <app-modal v-if="is_consent_modal"
                   modal-id="consent-modal"
                   modal-alignment="top"
                   modal-size="medium"
                   @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">Policy and Declaration</h5>
          </template>
          <template slot="body">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <policy-declaration-info :policy_declaration="policyDeclarationInfo" :companyInfo="companyInfo"
                                         :yesOrNoList="yesOrNoList"
                                         :isAdmin="false"/>
              </div>
            </div>
          </template>
          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="closeModal">
              {{ $t("close") }}
            </button>
            <button
                type="button"
                class="btn btn-secondary mr-2"
                @click.prevent="acceptAll">
              {{ $t("Accept & Continue") }}
            </button>
          </template>
        </app-modal>

    </div>
  </div>
</template>

<script>

import {SCREENING_USER_REGISTRATION} from '../../../../../../js/app/Config/ScreeningAppUrl';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
import {AuthMixin} from "../../Auth/Mixins/AuthMixin";
import moment from "moment";
import {_yesOrNoList} from '@Views/Screening/utility/constant';
import {dateFormatter, checkPolicyDeclaration} from '@Views/Screening/utility/common';
import {Candidate, File} from "@Views/Screening/utility/apiAgent";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import * as actions from "@/app/Config/ApiUrl";
import AppLibrary from "@/app/Helpers/AppLibrary";

export default {
  name: "CandidateRegistration",
  extends: AppLibrary,
  mixins: [FormMixin, AuthMixin],
  props: {
    companyInfo: {
      type: Object,
      default: () => ({})
    },
    applicant: {
      type: Object,
      default: () => ({})
    },
    configData: {
      type: Object,
      default: () => ({})
    },
    validationDefault: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    $("._remove_class").removeClass("el-button");
    this.getApplicantDetails();
    $("body").click(function () {
    });

    // Refresh the mandatory-field highlight as the candidate edits the form.
    // Capture phase so events bubbling up from nested step components are seen.
    this._onFormInput = () => this.scheduleRequiredHighlight();
    if (this.$refs.form) {
      this.$refs.form.addEventListener('input', this._onFormInput, true);
      this.$refs.form.addEventListener('change', this._onFormInput, true);
    }
  },
  beforeDestroy() {
    clearTimeout(this.aiHighlightTimer);
    if (this.$refs.form && this._onFormInput) {
      this.$refs.form.removeEventListener('input', this._onFormInput, true);
      this.$refs.form.removeEventListener('change', this._onFormInput, true);
    }
  },
  created() {
    this.setPolicyDeclarationFields();
    this.is_consent_modal = true;
    this.addUrl = window.location.pathname;

    // Set isRestrictedForm based on validationDefault
    if (this.validationDefault && Object.keys(this.validationDefault).length > 0) {
      this.isRestrictedForm = true;
    }

    // 🔹 Listen for document uploads to update local file list and validation
    this.$hub.$on('document-uploaded', (newFile) => {
      if (!this.basicInfo.files) {
        this.$set(this.basicInfo, 'files', []);
      }
      this.basicInfo.files.push(newFile);
      
      // Update missing documents list immediately
      if (this.missingDocuments && this.missingDocuments.length > 0) {
          this.missingDocuments = this.missingDocuments.filter(type => type !== newFile.type);
      }
    });

    // 🔹 Listen for document deletions
    this.$hub.$on('document-deleted', (deletedFile) => {
      if (this.basicInfo.files) {
        this.basicInfo.files = this.basicInfo.files.filter(f => f.id !== deletedFile.id);
      }

      const deletedType = `${deletedFile?.type || ''}`.toLowerCase();
      if (deletedType === 'sialicense' && Array.isArray(this.basicInfo.licenses)) {
        this.basicInfo.licenses = this.basicInfo.licenses.map((license) => {
          if(deletedFile?.id && license.license_id === deletedFile.id){
            license.license_id = null;
            license.license_name = null;
            license.license_path = null;
            license.licensePreview = null;
            license.pending_license_document = null;
          }
          return license;
        });
      }
    });
  },
  data() {
    return {
      isRestrictedForm: false,
      showCompletedStatus: false,
      is_consent_modal: false,
      basicInfo: {},
      payrollInfo: {},
      addressInfo: [],
      trainingInfo: [],
      candidateHistoryInfo: [],
      siaInfo: [],
      policyDeclarationInfo: {},
      gdprInfo: {},
      nextButton: false,
      active: 0,
      addUrl: SCREENING_USER_REGISTRATION,
      preloader: false,
      registrationForm: {},
      activeIdCollection: [],
      yesOrNoList: _yesOrNoList,
      emailAddress: '',
      maxStep: 7,
      shouldAdvanceStep: false, // <— added flag
      missingRanges: [],
      missingDocuments: [],
      aiExtracting: false,
      aiImportSummary: '',
      aiWarnings: [],
      fillChoiceModalVisible: false,
      aiConsentModalVisible: false,
      aiDocumentUploadModalVisible: false,
      aiConsentAccepted: false,
      aiHasDrivingLicense: false,
      aiDocuments: {
        cv: null,
        passport: null,
        bankStatement: null,
        utilityBill_1: null,
        utilityBill_2: null,
        siaLicense: null,
        driving_license: null,
      },
      aiDocumentErrors: [],
      aiUploadInputKey: 0,
      aiFillPrompted: false,
      aiFillPending: false,
      // Once the form has been autofilled, mandatory (label has *) fields that
      // are still empty are outlined in red so the candidate can see what is
      // left to complete. Re-evaluated on step change and as the user types.
      aiHighlightActive: false,
      aiHighlightTimer: null,
      allValidated: {
        sia: false,
        address: false,
        history: false,
        files: false,
      }

    };
  },
  watch: {
    showCompletedStatus(val) {
      if (val && window.confetti) {
        this.launchConfetti();
      }
    },
    active() {
      // The stepper only mounts the active step, so re-run the highlight every
      // time the user lands on a new step.
      if (this.aiHighlightActive) {
        this.$nextTick(() => this.applyRequiredHighlight());
      }
    }
  },
  methods: {
    openFillChoiceModal() {
      this.fillChoiceModalVisible = true;
    },

    chooseManualFill() {
      this.fillChoiceModalVisible = false;
    },

    chooseAiFill() {
      this.fillChoiceModalVisible = false;
      if (this.aiConsentAccepted) {
        this.syncAiDrivingLicenseSelection();
        this.aiDocumentUploadModalVisible = true;
        return;
      }
      this.aiConsentModalVisible = true;
    },

    acceptAiConsent() {
      this.aiConsentAccepted = true;
      this.aiConsentModalVisible = false;
      this.syncAiDrivingLicenseSelection();
      this.aiDocumentUploadModalVisible = true;
    },

    syncAiDrivingLicenseSelection() {
      if (this.basicInfo.is_driving_license === 'yes' || this.basicInfo.is_driving_license === true || this.basicInfo.is_driving_license === 1) {
        this.aiHasDrivingLicense = true;
      }
    },

    emptyAiDocuments() {
      return {
        cv: null,
        passport: null,
        bankStatement: null,
        utilityBill_1: null,
        utilityBill_2: null,
        siaLicense: null,
        driving_license: null,
      };
    },

    handleAiDocumentSelection(key, event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
      this.$set(this.aiDocuments, key, file);
      this.aiDocumentErrors = [];
    },

    cancelAiDocumentUpload() {
      this.aiDocumentUploadModalVisible = false;
      this.aiDocumentErrors = [];
    },

    resetAiDocumentUpload() {
      this.aiDocuments = this.emptyAiDocuments();
      this.aiDocumentErrors = [];
      this.aiHasDrivingLicense = false;
      this.aiUploadInputKey++;
    },

    validateAiDocuments() {
      const errors = [];
      this.aiDocumentUploadFields.forEach((document) => {
        if (document.required && !this.aiDocuments[document.key]) {
          errors.push(`${document.label} is required.`);
        }
      });
      this.aiDocumentErrors = errors;
      return errors.length === 0;
    },

    async processAiDocuments() {
      if (!this.validateAiDocuments()) {
        return;
      }

      const email = this.basicInfo.email || this.emailAddress || this.getEmailFromQueryString() || localStorage.getItem('candidate-email');

      this.aiExtracting = true;
      this.aiImportSummary = '';
      this.aiWarnings = [];

      const formData = new FormData();
      if (email) {
        formData.append('email', email);
      }

      Object.entries(this.aiDocuments).forEach(([key, file]) => {
        if (file) {
          formData.append(`documents[${key}]`, file);
        }
      });

      try {
        const response = await Candidate.extractDocuments(formData);
        const extracted = response?.data?.data || {};
        const storedFiles = response?.data?.files || [];
        const result = this.applyAiCandidateData(extracted);
        this.applyUploadedAiFiles(storedFiles);

        this.aiWarnings = Array.isArray(extracted.warnings) ? extracted.warnings : [];
        this.aiImportSummary = `${result.fields} field${result.fields === 1 ? '' : 's'}, ${result.entries} list entr${result.entries === 1 ? 'y' : 'ies'}, and ${storedFiles.length} file${storedFiles.length === 1 ? '' : 's'} imported.`;
        this.$toastr.s(response?.data?.message || 'Documents imported. Please review all fields carefully.');

        this.aiHighlightActive = true;
        this.aiDocumentUploadModalVisible = false;
        this.resetAiDocumentUpload();
        this.$nextTick(() => this.applyRequiredHighlight());
      } catch (error) {
        const errors = error?.response?.data?.errors;
        if (errors) {
          this.aiDocumentErrors = Object.values(errors).flat();
        }
        const message = this.aiDocumentErrors[0] || error?.response?.data?.message || 'The documents could not be processed. Please enter the information manually.';
        this.$toastr.e(message);
      } finally {
        this.aiExtracting = false;
      }
    },

    maybeOfferAiFill() {
      // Auto-offer the AI/manual choice once per page load, unless the application is already completed.
      if (this.aiFillPrompted || this.showCompletedStatus) return;
      // Never stack on top of the Policy & Declaration consent modal; defer until it is dismissed.
      if (this.is_consent_modal) {
        this.aiFillPending = true;
        return;
      }
      this.aiFillPrompted = true;
      this.fillChoiceModalVisible = true;
    },

    async handleCvUpload(event) {
      const document = event.target.files && event.target.files[0];
      if (!document) return;

      this.aiExtracting = true;
      this.aiImportSummary = '';
      this.aiWarnings = [];

      const formData = new FormData();
      formData.append('document', document);

      try {
        const response = await Candidate.extractCv(formData);
        const extracted = response?.data?.data || {};
        const result = this.applyAiCandidateData(extracted);

        this.aiWarnings = Array.isArray(extracted.warnings) ? extracted.warnings : [];
        this.aiImportSummary = `${result.fields} field${result.fields === 1 ? '' : 's'} and ${result.entries} list entr${result.entries === 1 ? 'y' : 'ies'} imported.`;
        this.$toastr.s(response?.data?.message || 'CV information imported. Please review it carefully.');

        // Outline any mandatory fields the CV did not cover so the candidate
        // can complete them before submitting.
        this.aiHighlightActive = true;
        this.$nextTick(() => this.applyRequiredHighlight());
      } catch (error) {
        const validationMessage = error?.response?.data?.errors?.document?.[0];
        const message = validationMessage || error?.response?.data?.message || 'The CV could not be processed. Please enter the information manually.';
        this.$toastr.e(message);
      } finally {
        this.aiExtracting = false;
        if (this.$refs.cvUpload) this.$refs.cvUpload.value = '';
      }
    },

    applyAiCandidateData(extracted) {
      let fields = 0;
      let entries = 0;

      Object.entries(extracted.basic_info || {}).forEach(([key, value]) => {
        if (!this.hasValue(value) || this.hasValue(this.basicInfo[key])) return;
        this.$set(this.basicInfo, key, value);
        fields++;
      });

      Object.entries(extracted.payroll || {}).forEach(([key, value]) => {
        if (!this.hasValue(value) || this.hasValue(this.payrollInfo[key])) return;
        this.$set(this.payrollInfo, key, key === 'sort_code' ? this.normalizeSortCode(value) : value);
        fields++;
      });

      entries += this.applyAiLicenses(extracted.licenses || []);

      (extracted.addresses || []).forEach((address) => {
        const normalized = this.normalizeAiAddress(address);
        if (!this.hasAddressIdentity(normalized) || this.hasDuplicateAddress(normalized)) return;
        this.addressInfo.push(normalized);
        entries++;
      });

      (extracted.employment || []).forEach((employment) => {
        const normalized = {
          ...employment,
          type: 0,
          current_status: !!employment.current_status,
          statusable_type: 'App\\Models\\Screening\\ApplicantEmployment',
          screening_status: [],
          start_date_formatted: employment.start_date ? this.dateFormatter(employment.start_date) : '',
          end_date_formatted: employment.current_status
              ? 'Till Present'
              : (employment.end_date ? this.dateFormatter(employment.end_date) : ''),
        };
        if (!this.hasValue(normalized.company_name) || this.hasDuplicateHistory(normalized)) return;
        this.candidateHistoryInfo.push(normalized);
        entries++;
      });

      (extracted.education || []).forEach((education) => {
        const normalized = {
          ...education,
          type: 1,
          current_status: !!education.current_status,
          statusable_type: 'App\\Models\\Screening\\ApplicantEducation',
          screening_status: [],
          start_date_formatted: education.start_date ? this.dateFormatter(education.start_date) : '',
          end_date_formatted: education.current_status
              ? 'Till Present'
              : (education.end_date ? this.dateFormatter(education.end_date) : ''),
        };
        if (!this.hasValue(normalized.institute) || this.hasDuplicateHistory(normalized)) return;
        this.candidateHistoryInfo.push(normalized);
        entries++;
      });

      (extracted.training || []).forEach((training) => {
        const normalized = {
          ...training,
          screening_status: [],
        };
        if (!this.hasValue(normalized.title) || this.hasDuplicateTraining(normalized)) return;
        this.trainingInfo.push(normalized);
        entries++;
      });

      return {fields, entries};
    },

    applyAiLicenses(licenses) {
      if (!Array.isArray(licenses) || !licenses.length) {
        return 0;
      }

      const normalizedLicenses = licenses
          .map((license, index) => ({
            uid: license.uid || `${Date.now()}-${index}`,
            type: license.type || '',
            number: license.number || '',
            issueDate: license.issueDate || null,
            expiry: license.expiry || null,
            license_document: null,
            pending_license_document: null,
            license_path: null,
            license_id: null,
            license_name: null,
            licensePreview: null,
          }))
          .filter((license) => [license.type, license.number, license.expiry].some((value) => this.hasValue(value)));

      if (!normalizedLicenses.length) {
        return 0;
      }

      const existingLicenses = Array.isArray(this.basicInfo.licenses) ? this.basicInfo.licenses : [];
      const meaningfulExisting = existingLicenses.filter((license) => [
        license.type,
        license.number,
        license.expiry,
        license.license_path,
      ].some((value) => this.hasValue(value)));

      let added = 0;
      const merged = [...meaningfulExisting];

      normalizedLicenses.forEach((license) => {
        const duplicate = merged.some((existing) => [
          existing.type,
          existing.number,
          existing.expiry,
        ].map((value) => this.normalizedValue(value)).join('|') === [
          license.type,
          license.number,
          license.expiry,
        ].map((value) => this.normalizedValue(value)).join('|'));

        if (!duplicate) {
          merged.push(license);
          added++;
        }
      });

      if (merged.length) {
        this.$set(this.basicInfo, 'licenses', merged);
      }

      return added;
    },

    normalizeSortCode(value) {
      const digits = `${value || ''}`.replace(/\D/g, '').slice(0, 6);
      if (digits.length <= 2) return digits;
      if (digits.length <= 4) return digits.replace(/(\d{2})(\d+)/, '$1-$2');
      return digits.replace(/(\d{2})(\d{2})(\d+)/, '$1-$2-$3');
    },

    applyUploadedAiFiles(files) {
      if (!Array.isArray(files) || !files.length) {
        return;
      }

      if (!Array.isArray(this.basicInfo.files)) {
        this.$set(this.basicInfo, 'files', []);
      }

      files.forEach((file) => {
        if (!this.basicInfo.files.some((existing) => existing.id === file.id)) {
          this.basicInfo.files.push(file);
        }

        if (this.missingDocuments && this.missingDocuments.length > 0) {
          this.missingDocuments = this.missingDocuments.filter((type) => type !== file.type);
        }

        if (file.type === 'passport') {
          this.$set(this.basicInfo, 'passport_path', file.file_path);
          this.$set(this.basicInfo, 'passport_id', file.id);
          this.$set(this.basicInfo, 'passport_name', file.file_name);
        }

        if (file.type === 'driving_license') {
          this.$set(this.basicInfo, 'is_driving_license', 'yes');
          this.$set(this.basicInfo, 'driving_license_path', file.file_path);
          this.$set(this.basicInfo, 'driving_license_id', file.id);
          this.$set(this.basicInfo, 'driving_license_name', file.file_name);
        }

        if (file.type === 'siaLicense') {
          this.attachSiaFileToFirstLicense(file);
        }
      });
    },

    attachSiaFileToFirstLicense(file) {
      const licenses = Array.isArray(this.basicInfo.licenses) && this.basicInfo.licenses.length
          ? [...this.basicInfo.licenses]
          : [{
            uid: `${Date.now()}-sia`,
            type: '',
            number: '',
            issueDate: null,
            expiry: null,
            license_document: null,
            pending_license_document: null,
          }];

      const index = licenses.findIndex((license) => !license.license_id);
      const targetIndex = index === -1 ? 0 : index;
      licenses[targetIndex] = {
        ...licenses[targetIndex],
        license_path: file.file_path,
        license_id: file.id,
        license_name: file.file_name,
        licensePreview: file.file_path,
        license_document: null,
        pending_license_document: null,
      };

      this.$set(this.basicInfo, 'licenses', licenses);
    },

    normalizeAiAddress(address) {
      const normalized = {
        ...address,
        current_status: !!address.current_status,
      };
      if (normalized.current_status) normalized.to_date = null;

      normalized.address = [
        normalized.door_number,
        normalized.street,
        normalized.city,
        normalized.county,
        normalized.post_code,
        normalized.country,
      ].filter(this.hasValue).join(', ');

      return normalized;
    },

    hasValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== '';
    },

    /* ----- mandatory-field highlight (after AI autofill) ---------------- */

    // Outline every required field (its label contains a red "*") that is still
    // empty on the currently visible step. Filled fields have the outline
    // removed, so it doubles as live feedback as the candidate completes them.
    applyRequiredHighlight() {
      const root = this.$refs.form;
      if (!root || this.showCompletedStatus) return;

      root.querySelectorAll('label').forEach((label) => {
        const marker = label.querySelector('.text-danger');
        if (!marker || !marker.textContent.includes('*')) return;

        const group = label.closest('.form-group') || label.parentElement;
        if (!group) return;

        // Only consider visible controls of the same field group.
        const controls = Array.from(
          group.querySelectorAll('input:not([type="hidden"]), select, textarea')
        ).filter((el) => el.offsetParent !== null);
        if (!controls.length) return;

        const filled = this.isRequiredGroupFilled(group, controls);
        controls.forEach((el) => {
          el.classList.toggle('ai-required-field-empty', !filled);
        });
      });
    },

    isRequiredGroupFilled(group, controls) {
      // An existing image/document preview (e.g. an already uploaded picture)
      // means the field is satisfied even if the file input itself is empty.
      if (group.querySelector('.document-preview-container, img')) return true;
      return controls.some((el) => this.isControlFilled(el));
    },

    isControlFilled(el) {
      const tag = el.tagName.toLowerCase();
      if (tag === 'select') return this.hasValue(el.value);
      if (el.type === 'checkbox' || el.type === 'radio') return el.checked;
      if (el.type === 'file') return !!(el.files && el.files.length);
      return this.hasValue(el.value);
    },

    // Re-evaluate the highlight as the user edits, so red outlines clear the
    // moment a mandatory field is filled. Debounced to stay cheap on keystrokes.
    scheduleRequiredHighlight() {
      if (!this.aiHighlightActive) return;
      clearTimeout(this.aiHighlightTimer);
      this.aiHighlightTimer = setTimeout(() => this.applyRequiredHighlight(), 200);
    },

    normalizedValue(value) {
      return this.hasValue(value) ? String(value).trim().toLowerCase() : '';
    },

    hasAddressIdentity(address) {
      return [address.street, address.city, address.post_code, address.country].some(this.hasValue);
    },

    hasDuplicateAddress(candidate) {
      const key = [candidate.street, candidate.city, candidate.post_code, candidate.from_date]
          .map(this.normalizedValue)
          .join('|');

      return this.addressInfo.some((address) => [address.street, address.city, address.post_code, address.from_date]
          .map(this.normalizedValue)
          .join('|') === key);
    },

    hasDuplicateHistory(candidate) {
      const organization = candidate.type === 0 ? candidate.company_name : candidate.institute;
      const key = [candidate.type, organization, candidate.start_date, candidate.end_date]
          .map(this.normalizedValue)
          .join('|');

      return this.candidateHistoryInfo.some((history) => {
        const existingOrganization = history.type === 0 ? history.company_name : history.institute;
        return [history.type, existingOrganization, history.start_date, history.end_date]
            .map(this.normalizedValue)
            .join('|') === key;
      });
    },

    hasDuplicateTraining(candidate) {
      const key = [candidate.title, candidate.awarding_body, candidate.award_date]
          .map(this.normalizedValue)
          .join('|');

      return this.trainingInfo.some((training) => [training.title, training.awarding_body, training.award_date]
          .map(this.normalizedValue)
          .join('|') === key);
    },

    launchConfetti() {
      const duration = 5 * 1000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      const randomInRange = (min, max) => Math.random() * (max - min) + min;

      const interval = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
      }, 250);
    },
    dateFormatter,
    checkPolicyDeclaration,
    async handleStepChange(newStepIndex) {
      if (newStepIndex === this.active) return;
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Block step change on failure
        }
      }

      this.activeIdCollection.push(newStepIndex);
      this.active = newStepIndex;
    },

    validator() {
      if (this.active === 2) {
        return this.addressHistoryValidation();
      }
      if (this.active === 4) {
        return this.candidateHistoryValidation();
      }
      if (this.active === 6) {
        return this.documentsValidation();
      }
      return true;
    },
    addressHistoryValidation() {
      const comp = this.$refs.addressInfo;
      // If not restricted, skip blocking validation entirely
      if (comp && (comp.restrictValidation === false || !this.isRestrictedForm)) {
        return true;
      }
      const hasAddresses = Array.isArray(this.addressInfo) && this.addressInfo.length > 0;
      if (!hasAddresses) return false;
      const hasGaps = comp && Array.isArray(comp.gaps) && comp.gaps.length > 0;
      const notCoveredFiveYears = comp && comp.isFiveYearsCovered === false;
      if (hasGaps || notCoveredFiveYears) {
        this.$toastr.e('Missing address history. Please fill the gaps.');
        return false;
      }
      return true;
    },
    candidateHistoryValidation() {
      // Respect restricted mode only
      if (!this.isRestrictedForm || (this.validationDefault && !this.validationDefault.employmentHistory)) {
        return true;
      }
      const hasHistory = Array.isArray(this.candidateHistoryInfo) && this.candidateHistoryInfo.length > 0;
      if (!hasHistory) return false;
      const comp = this.$refs.candidateHistory;
      const hasGaps = comp && Array.isArray(comp.historyGaps) && comp.historyGaps.length > 0;
      if (hasGaps) {
        this.$toastr.e('Missing previous employment. Please fill the gaps.');
        return false;
      }
      return true;
    },
    documentsValidation() {
      if (!this.isRestrictedForm || (this.validationDefault && !this.validationDefault.documents)) {
        return true;
      }
      // Frontend check if we have files loaded
      if (this.basicInfo && Array.isArray(this.basicInfo.files)) {
        const uploadedTypes = this.basicInfo.files.map(f => f.type);
        const requiredTypes = [
          'passport',
          'bankStatement',
          'utilityBill_1',
          'utilityBill_2',
          'siaLicense',
        ];
        if (this.basicInfo.is_driving_license === 'yes' || this.basicInfo.is_driving_license === true || this.basicInfo.is_driving_license === 1) {
            requiredTypes.push('driving_license');
        }

        const missing = requiredTypes.filter(type => !uploadedTypes.includes(type));
        if (missing.length > 0) {
          this.missingDocuments = missing;
          this.$toastr.e('Please upload all required documents.');
          return false;
        }
      }
      
      // If we already have missing documents from server, block
      if (this.missingDocuments && this.missingDocuments.length > 0) {
        this.$toastr.e('Please upload all required documents.');
        return false;
      }
      return true;
    },
    previous() {
      this.fieldStatus.isSubmit = false;
      if (this.active-- < this.maxStep) this.active = this.active--;
      if(this.active < 8){
        this.showCompletedStatus = false
      }
    },
    async stepClick(_, id) {
      this.fieldStatus.isSubmit = false;
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      // Stop if basic or general validation fails
      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      // Extra validation for SIA step (step 5)
      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Custom validation failed
        }
      }

      // All validation passed — move to the selected step
      this.activeIdCollection.push(id);
      this.active = id;
    },


    getEmailFromQueryString() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      return params.email ?? false;

    },
    getApplicantDetails() {
      let ifEmailInQueryString = this.getEmailFromQueryString();
      if (this.applicant && this.applicant.email) {
        ifEmailInQueryString = this.applicant.email;
      }
      let _email = ifEmailInQueryString ?? localStorage.getItem('candidate-email');
      this.preloader = true;
      Candidate.getCandidateByEmail(_email)
          .then(({data}) => {
            if (data?.applicant && Object.values(data?.applicant).length > 0) {
              this.setApiResponseIntoBasicInfoProps(data.applicant, data.applicant.files);
              this.setApiResponseIntoPayrollProps(data.applicant?.applicant_payroll);
              this.setApiResponseIntoPolicyDeclrationProps(data.applicant?.applicant_policy_declaration);
              this.setApiResponseIntoGdprProps(data.applicant?.applicant_gdpr_detail);
              this.setApiResponseIntoTrainingProps(data.applicant?.applicant_training);
              this.setApiResponseIntoAddressProps(data.applicant?.applicant_address);
              this.setApiResponseIntoSIAProps(data.applicant?.applicant_sia_detail);
              this.setApiResponseIntoPreviousHistoryProps({
                employment: data.applicant?.applicant_employment,
                education: data.applicant?.applicant_education,
                selfEmployment: data.applicant?.applicant_self_employment,
                unEmployment: data.applicant?.applicant_unemployment,
                applicantEmail: data.applicant?.email,
              });
            } else if(_email) {
              this.$set(this.basicInfo, 'email', _email);
              // window.location.reload();
            }else{
              localStorage.removeItem('candidate-email');
            }
          })
          .finally(() => {
            this.preloader = false;
            this.maybeOfferAiFill();
          });
    },
    setApiResponseIntoBasicInfoProps(applicant, files = null) {
      this.$set(this.basicInfo, 'employee_picture_path', null);
      this.$set(this.basicInfo, 'employee_picture_name', null);
      this.$set(this.basicInfo, 'pending_profile_pic', null);
      this.$set(this.basicInfo, 'employeeImagePreview', null);
      this.$set(this.basicInfo, 'passport_path', null);
      this.$set(this.basicInfo, 'passport_name', null);
      this.$set(this.basicInfo, 'pending_passport', null);
      this.$set(this.basicInfo, 'passportPreview', null);
      this.$set(this.basicInfo, 'driving_license_path', null);
      this.$set(this.basicInfo, 'driving_license_name', null);
      this.$set(this.basicInfo, 'pending_driving_license', null);
      this.$set(this.basicInfo, 'drivingLicensePreview', null);
      this.$set(this.basicInfo, 'driving_license_document', null);
      this.$set(this.basicInfo, 'passport', null);
      this.$set(this.basicInfo, 'employee_picture', null);

      this.$set(this.basicInfo, 'files', files);

      if (files && Array.isArray(files)) {
        const profilePic = files.filter(f => f.type === 'profile_pic').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);
        
        if (profilePic) {
          this.$set(this.basicInfo, 'employee_picture_path', profilePic.file_path);
          this.$set(this.basicInfo, 'employee_picture_name', profilePic.file_name);
          this.$set(this.basicInfo, 'employee_picture_id', profilePic.id);
        }

        const passportFile = files.filter(f => f.type === 'passport').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (passportFile) {
          this.$set(this.basicInfo, 'passport_path', passportFile.file_path);
          this.$set(this.basicInfo, 'passport_name', passportFile.file_name);
          this.$set(this.basicInfo, 'passport_id', passportFile.id);
        }

        const drivingLicenseFile = files.filter(f => f.type === 'driving_license').reduce((prev, current) => {
          return (Number(current.id) > (Number(prev?.id) || 0)) ? current : prev;
        }, null);

        if (drivingLicenseFile) {
          this.$set(this.basicInfo, 'driving_license_path', drivingLicenseFile.file_path);
          this.$set(this.basicInfo, 'driving_license_name', drivingLicenseFile.file_name);
          this.$set(this.basicInfo, 'driving_license_id', drivingLicenseFile.id);
        }
      }

      this.$set(this.basicInfo, 'position_applied', applicant.position_applied);
      this.$set(this.basicInfo, 'full_name', applicant.full_name);
      this.$set(this.basicInfo, 'forename', applicant.forename);
      this.$set(this.basicInfo, 'middle_name', applicant.middle_name);
      this.$set(this.basicInfo, 'surname', applicant.surname);
      this.$set(this.basicInfo, 'n_i_number', applicant.n_i_number);
      this.$set(this.basicInfo, 'gender', applicant.gender);
      this.$set(this.basicInfo, 'date_of_birth', applicant.date_of_birth);
      this.$set(this.basicInfo, 'title', applicant.title);
      this.$set(this.basicInfo, 'country_of_birth', applicant.country_of_birth);
      this.$set(this.basicInfo, 'town_of_birth', applicant.town_of_birth);
      this.$set(this.basicInfo, 'photo_id_match', applicant.photo_id_match);
      this.$set(this.basicInfo, 'nationality', applicant.nationality);
      this.$set(this.basicInfo, 'edbs_number', applicant.edbs_number);
      this.$set(this.basicInfo, 'contact_number', applicant.contact_number ?? '');
      this.$set(this.basicInfo, 'alternative_contact_no', applicant.alternative_contact_no ?? '');
      this.$set(this.basicInfo, 'email', applicant.email);
      this.$set(this.basicInfo, 'additional_email', applicant.additional_email);
      this.$set(this.basicInfo, 'report_email', applicant.report_email || 'primary');
      this.$set(this.basicInfo, 'relationship', applicant.relationship);
      this.$set(this.basicInfo, 'next_of_kin', applicant.next_of_kin);
      this.$set(this.basicInfo, 'next_of_kin_contact_no', applicant.next_of_kin_contact_no ?? '');
      this.$set(this.basicInfo, 'is_sia_required', applicant.is_sia_required === 1 ? true : false);
      this.$set(this.basicInfo, 'sia_license_number', applicant.sia_license_number);
      this.$set(this.basicInfo, 'sia_license_type', applicant.sia_license_type);
      this.$set(this.basicInfo, 'sia_license_expiry', applicant.sia_license_expiry);
      this.$set(this.basicInfo, 'is_additional_license', applicant.is_additional_license === 1 ? true : false);
      this.$set(this.basicInfo, 'additional_sia_license_number', applicant.additional_sia_license_number);
      this.$set(this.basicInfo, 'additional_sia_license_type', applicant.additional_sia_license_type);
      this.$set(this.basicInfo, 'additional_sia_license_expiry', applicant.additional_sia_license_expiry);
      this.$set(this.basicInfo, 'share_code', applicant.share_code);
      this.$set(this.basicInfo, 'share_code_start_date', applicant.share_code_start_date);
      this.$set(this.basicInfo, 'employee_picture', applicant.employee_picture);
      this.$set(this.basicInfo, 'is_visa_require_uk', applicant.is_visa_require_uk);
      this.$set(this.basicInfo, 'visa_type', applicant.visa_type);
      this.$set(this.basicInfo, 'biometric_residence_permit', applicant.biometric_residence_permit);
      this.$set(this.basicInfo, 'visa_expiry', applicant.visa_expiry);
      this.$set(this.basicInfo, 'date_of_entry_re_entry', applicant.date_of_entry_re_entry);
      this.$set(this.basicInfo, 'is_have_p45_or_p46', applicant.is_have_p45_or_p46);
      this.$set(this.basicInfo, 'copy_of_p45', applicant.copy_of_p45);
      this.$set(this.basicInfo, 'p46_detail', applicant.p46_detail);
      this.$set(this.basicInfo, 'is_other_employment', applicant.is_other_employment);
      this.$set(this.basicInfo, 'continue_other_employment', applicant.continue_other_employment);
      this.$set(this.basicInfo, 'is_leisure', applicant.is_leisure);
      this.$set(this.basicInfo, 'leisure_details', applicant.leisure_details);
      this.$set(this.basicInfo, 'is_criminal_record', applicant.is_criminal_record);
      this.$set(this.basicInfo, 'criminal_record_details', applicant.criminal_record_details);
      this.$set(this.basicInfo, 'is_bankruptcy', applicant.is_bankruptcy);
      this.$set(this.basicInfo, 'bankruptcy_details', applicant.bankruptcy_details);
      this.$set(this.basicInfo, 'is_days_shift_cant_work', applicant.is_days_shift_cant_work);
      this.$set(this.basicInfo, 'days_shift_cant_work_details', applicant.days_shift_cant_work_details);
      this.$set(this.basicInfo, 'is_holidays_commitment', applicant.is_holidays_commitment);
      this.$set(this.basicInfo, 'holidays_commitment_details', applicant.holidays_commitment_details);
      this.$set(this.basicInfo, 'is_own_vehicle', applicant.is_own_vehicle);
      this.$set(this.basicInfo, 'is_driving_license', applicant.is_driving_license);
      this.$set(this.basicInfo, 'driver_license_number', applicant.driver_license_number);
      this.$set(this.basicInfo, 'license_type', applicant.license_type);
      this.$set(this.basicInfo, 'license_issue_date', applicant.license_issue_date);
      this.$set(this.basicInfo, 'license_expiry_date', applicant.license_expiry_date);
      if (applicant.licenses && Array.isArray(applicant.licenses) && files && Array.isArray(files)) {
        const cleanedLicenses = applicant.licenses.map(license => {
          if (license.license_id) {
            const fileExists = files.some(f => f.id == license.license_id);
            if (!fileExists) {
              return {
                ...license,
                license_id: null,
                license_path: null,
                license_name: null,
                licensePreview: null,
                pending_license_document: null,
                license_document: null
              };
            }
          }
          return license;
        });
        this.$set(this.basicInfo, 'licenses', cleanedLicenses);
      } else {
        this.$set(this.basicInfo, 'licenses', applicant.licenses);
      }
    },
    setApiResponseIntoPayrollProps(payroll) {
      if (payroll && Object.values(payroll).length > 0) {
        this.$set(this.payrollInfo, 'account_name', payroll.account_name);
        this.$set(this.payrollInfo, 'account_number', payroll.account_number);
        this.$set(this.payrollInfo, 'bank_name', payroll.bank_name);
        this.$set(this.payrollInfo, 'other_information', payroll.other_information);
        this.$set(this.payrollInfo, 'sort_code', payroll.sort_code);
      }
    },
    setApiResponseIntoAddressProps(address) {
      if (address && address.length > 0) {
        this.addressInfo = address;
      }
    },
    setApiResponseIntoTrainingProps(training) {
      if (training && training.length > 0) {
        this.trainingInfo = training;
        this.$set(this.trainingInfo, 'emailAddress', this.basicInfo.email);

      }
    },
    setApiResponseIntoPreviousHistoryProps(previousHistory) {
      this.candidateHistoryInfo = [];
      const mapFiles = (item) => {
        if (item.applicant_files && Array.isArray(item.applicant_files)) {
          return { ...item, files: item.applicant_files.map(f => ({ ...f, file_name: f.file_name || f.name, file_path: f.file_path || f.path })) };
        }
        return item;
      };

      if (previousHistory.employment && previousHistory.employment.length > 0) {
        for (const employment of previousHistory.employment) {
          this.candidateHistoryInfo.push(mapFiles({...employment, type: 0}));
        }
      }
      if (previousHistory.education && previousHistory.education.length > 0) {
        for (const education of previousHistory.education) {
          this.candidateHistoryInfo.push(mapFiles({...education, type: 1}));
        }
      }
      if (previousHistory.selfEmployment && previousHistory.selfEmployment.length > 0) {
        for (const selfEmployment of previousHistory.selfEmployment) {
          this.candidateHistoryInfo.push(mapFiles({...selfEmployment, type: 2}));
        }
      }
      if (previousHistory.unEmployment && previousHistory.unEmployment.length > 0) {
        for (const unEmployment of previousHistory.unEmployment) {
          this.candidateHistoryInfo.push(mapFiles({...unEmployment, type: 3}));
        }
      }
    },
    setApiResponseIntoSIAProps(sia) {
      if (sia && sia.length > 0) {
        this.siaInfo = sia
      }
    },
    setApiResponseIntoGdprProps(gdpr) {
      if (gdpr && Object.values(gdpr).length > 0) {

        this.$set(this.gdprInfo, 'consent', gdpr.consent === 1 ? true : false);
        this.$set(this.gdprInfo, 'consent_date_time', gdpr.consent_date_time);
        this.$set(this.gdprInfo, 'special_category_data', gdpr.special_category_data === 1 ? true : false);
        this.$set(this.gdprInfo, 'signature', gdpr.signature);
        this.$set(this.gdprInfo, 'criminal', gdpr.criminal);
        this.$set(this.gdprInfo, 'financial', gdpr.financial);
        this.$set(this.gdprInfo, 'health', gdpr.health);
        this.$set(this.gdprInfo, 'diversity', gdpr.diversity);
        this.$set(this.gdprInfo, 'biometric', gdpr.biometric);
        this.$set(this.gdprInfo, 'companyInfo', this.companyInfo);
      }
    },
    setApiResponseIntoPolicyDeclrationProps(policyDeclration) {
      if (policyDeclration && Object.values(policyDeclration).length > 0) {
        this.$set(this.policyDeclarationInfo, 'applicant_screening', policyDeclration.applicant_screening === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'criminal_background_check', policyDeclration.criminal_background_check === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', policyDeclration.declaration_by_applicant === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'financial_history', policyDeclration.financial_history === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality', policyDeclration.equality === 1 ? true : false);
        this.$set(this.policyDeclarationInfo, 'equality_details', policyDeclration.equality_details);
        this.$set(this.policyDeclarationInfo, 'working_time_directive', policyDeclration.working_time_directive);
      }
    },
    closeModal() {
      this.is_consent_modal = false;
      $("#consent-modal").modal("hide");
      // Once the consent modal is dismissed, surface the deferred AI/manual autofill choice.
      if (this.aiFillPending) {
        this.aiFillPending = false;
        setTimeout(() => this.maybeOfferAiFill(), 350);
      }
    },
    acceptAll() {
      this.$set(this.policyDeclarationInfo, 'applicant_screening', true);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check', true);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', true);
      this.$set(this.policyDeclarationInfo, 'financial_history', true);
      this.$set(this.policyDeclarationInfo, 'equality', true);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'yes');
      setTimeout(() => {
        this.closeModal()
      }, 1000 )

    },
    setPolicyDeclarationFields(){
      this.$set(this.policyDeclarationInfo, 'applicant_screening', false);
      this.$set(this.policyDeclarationInfo, 'criminal_background_check',  false);
      this.$set(this.policyDeclarationInfo, 'declaration_by_applicant', false);
      this.$set(this.policyDeclarationInfo, 'financial_history', false);
      this.$set(this.policyDeclarationInfo, 'equality', false);
      this.$set(this.policyDeclarationInfo, 'working_time_directive', 'no');
    },
    confirmSubmission(lastFormIndex) {
      if (confirm("Are you sure all the information is correct and you want to submit? You may cancel and go back to review your information." )) {
        return true; // Proceed with submission
      } else {
        this.active = 0; // Take the user back to the previous step for review
        return false;
      }
    },
    async next() {
      const isValidated = this.validator();
      const validBasicInfo = this.isValidForm();

      // ✅ Validate fields from AppInput-based components
      if (this.$refs.basicInfo !== undefined) {
        this.$refs.basicInfo.fieldStatus.isSubmit = true;
      }
      if (this.$refs.payrollInfo !== undefined) {
        this.$refs.payrollInfo.fieldStatus.isSubmit = true;
      }

      // ❌ Stop if built-in validation fails
      if (!isValidated || !validBasicInfo) {
        this.fieldStatus.isSubmit = true;
        this.$toastr.e("Please fill in the required fields.");
        return;
      }

      // ✅ File validation
      if (!this.validateFiles()) {
        return;
      }

      // ✅ Check if this step has extra validation (e.g., SIA step = step 5)
      if (this.active === 5 && this.$refs.siaStep) {
        try {
          await this.$refs.siaStep.validateForm();
        } catch {
          return; // Validation failed; don't proceed
        }
      }

      // ✅ Set this flag BEFORE triggering save
      this.shouldAdvanceStep = true;

      // 🔄 Continue with backend save; afterSuccess will advance the step
      this.saveBtnHandler(false);
    },

    validateFiles() {
      if (this.active === 0) {
        // Applicant Picture
        if (!this.basicInfo.pending_profile_pic && !this.basicInfo.employee_picture_path) {
          this.$toastr.e("Applicant Picture is required.");
          return false;
        }

        // Licenses - Always validate SIA licenses
        if (this.basicInfo.licenses && this.basicInfo.licenses.length > 0) {
          for (let i = 0; i < this.basicInfo.licenses.length; i++) {
            const license = this.basicInfo.licenses[i];
            if (!license.pending_license_document && !license.license_path) {
              this.$toastr.e(`SIA License document is required for License ${i + 1}.`);
              return false;
            }
          }
        }

        // Driving License
        if (this.basicInfo.is_driving_license === 'yes' || this.basicInfo.is_driving_license === true || this.basicInfo.is_driving_license === 1) {
          if (!this.basicInfo.pending_driving_license && !this.basicInfo.driving_license_path) {
            this.$toastr.e("Driving License document is required.");
            return false;
          }
        }

        // Right to Work
        if (this.basicInfo.is_visa_require_uk === 'no' || this.basicInfo.is_visa_require_uk === false || this.basicInfo.is_visa_require_uk === 0) {
          if (!this.basicInfo.pending_passport && !this.basicInfo.passport_path) {
            this.$toastr.e("Proof of right to work (Passport/Birth Certificate) is required.");
            return false;
          }
        }
      }

      if (this.active === 3) {
        // Training Information
        if (this.trainingInfo && this.trainingInfo.length > 0) {
          for (let i = 0; i < this.trainingInfo.length; i++) {
            const training = this.trainingInfo[i];
            if (!training.certificate_path && !training.pending_certificate) {
              this.$toastr.e(`Upload Certificate for training: ${training.title}.`);
              return false;
            }
          }
        }
      }

      // Document validation removed as per requirement

      return true;
    },



    async saveBtnHandler(final = true) {
      if (!final) {
        if (this.lastFormIndex === this.maxStep && !this.confirmSubmission()) {
          return;
        }
      }

      if (!this.checkPolicyDeclaration(this.policyDeclarationInfo)) {
        this.is_consent_modal = true;
        return;
      }

      let employment = this.candidateHistoryInfo.filter(x => x.type === 0);
      let education = this.candidateHistoryInfo.filter(x => x.type === 1);
      let selfEmployment = this.candidateHistoryInfo.filter(x => x.type === 2);
      let unEmployment = this.candidateHistoryInfo.filter(x => x.type === 3);

      if (this.basicInfo.visa_type_others)
        this.basicInfo.visa_type = this.basicInfo.visa_type_others;

      this.registrationForm = {
        applicant: this.basicInfo,
        applicantPayroll: this.payrollInfo,
        applicantAddress: this.addressInfo,
        applicantTraining: this.trainingInfo,
        applicantEmployment: employment,
        applicantEducation: education,
        applicantSelfEmployment: selfEmployment,
        applicantUnemployment: unEmployment,
        applicantSiaDetail: this.siaInfo,
        applicantGdprDetail: this.gdprInfo,
        applicantPolicyDeclaration: this.policyDeclarationInfo,
        searchAction: this.searchAction ?? [],
        currentStep: this.active,
        validationStatus: this.allValidated
      };

      // Handle pending files if they exist
      const hasPendingLicenses = this.basicInfo.licenses?.some(l => l.pending_license_document);
      if (this.basicInfo.pending_profile_pic || this.basicInfo.pending_passport || this.basicInfo.pending_driving_license || hasPendingLicenses) {
        this.beforeSubmit(); // setting preloader to true
        try {
          if (this.basicInfo.pending_profile_pic) {
            if (this.basicInfo.employee_picture_id) {
              await File.deleteDocument(this.basicInfo.employee_picture_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'profile_pic');
            formData.append('files', this.basicInfo.pending_profile_pic);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'employee_picture_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'employee_picture_id', uploadedFile.id);
              this.$set(this.basicInfo, 'employee_picture_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_profile_pic', null);
            this.$set(this.basicInfo, 'employeeImagePreview', null);
            this.$set(this.basicInfo, 'employee_picture', null);
          }
          if (this.basicInfo.pending_passport) {
            if (this.basicInfo.passport_id) {
              await File.deleteDocument(this.basicInfo.passport_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'passport');
            formData.append('files', this.basicInfo.pending_passport);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'passport_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'passport_id', uploadedFile.id);
              this.$set(this.basicInfo, 'passport_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_passport', null);
            this.$set(this.basicInfo, 'passportPreview', null);
            this.$set(this.basicInfo, 'passport', null);
          }
          if (this.basicInfo.pending_driving_license) {
            if (this.basicInfo.driving_license_id) {
              await File.deleteDocument(this.basicInfo.driving_license_id);
            }
            let formData = new FormData();
            formData.append('email', this.basicInfo.email);
            formData.append('type', 'driving_license');
            formData.append('files', this.basicInfo.pending_driving_license);
            const response = await File.uploadDocument(formData);
            const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
            if (uploadedFile && uploadedFile.file_path) {
              this.$set(this.basicInfo, 'driving_license_path', uploadedFile.file_path);
              this.$set(this.basicInfo, 'driving_license_id', uploadedFile.id);
              this.$set(this.basicInfo, 'driving_license_name', uploadedFile.file_name);
            }
            this.$set(this.basicInfo, 'pending_driving_license', null);
            this.$set(this.basicInfo, 'drivingLicensePreview', null);
            this.$set(this.basicInfo, 'driving_license_document', null);
          }

          /*if (this.basicInfo.licenses && Array.isArray(this.basicInfo.licenses)) {
            for (let i = 0; i < this.basicInfo.licenses.length; i++) {
              const license = this.basicInfo.licenses[i];
              if (license.pending_license_document) {
                if (license.license_id) {
                  await File.deleteDocument(license.license_id);
                }
                let formData = new FormData();
                formData.append('email', this.basicInfo.email);
                formData.append('type', 'siaLicense');
                formData.append('files', license.pending_license_document);
                const response = await File.uploadDocument(formData);
                const uploadedFile = (response.data && response.data.data && response.data.data.length > 0) ? response.data.data[0] : null;
                if (uploadedFile && uploadedFile.file_path) {
                  this.$set(license, 'license_path', uploadedFile.file_path);
                  this.$set(license, 'license_id', uploadedFile.id);
                  this.$set(license, 'license_name', uploadedFile.file_name);
                }
                this.$set(license, 'pending_license_document', null);
                this.$set(license, 'licensePreview', null);
                this.$set(license, 'license_document', null);
              }
            }
          }*/
        } catch (error) {
          this.$toastr.e("Failed to upload some files.");
        } finally {
          this.preloader = false;
        }
      }

      this.beforeSubmit();
      this.save(this.registrationForm);
    },


    beforeSubmit() {
      this.preloader = true;
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.missingDocuments = res.data.missing_documents || [];
      this.missingRanges = res.data.missing_ranges || [];
      this.$emit('afterSubmitDone');

      if (this.shouldAdvanceStep) {
        if (this.active < this.maxStep) {
          this.active++;
          this.activeIdCollection.push(this.active);
          $("#_remove_class_").removeClass("el-button");
        } else {
          this.showCompletedStatus = true;
        }
      }else if (res.data.currentStep === 7){
        this.missingDocuments = [];
        this.missingRanges = [];
        this.showCompletedStatus = true;
      }
      const stepMap = {
        sia: 0,
        address: 2,
        history: 4,
        files: 6,
      };
      for (const [key, index] of Object.entries(stepMap)) {
        if (res.data.currentStep === index) {
          this.allValidated[key] = true;
        }
      }

      this.fieldStatus.isSubmit = false;

      this.shouldAdvanceStep = false; // ✅ always reset
      if (res.data.applicant) {
        this.setApiResponseIntoBasicInfoProps(res.data.applicant, res.data.applicant.files);
        this.setApiResponseIntoPreviousHistoryProps({
          employment: res.data.applicant?.applicant_employment,
          education: res.data.applicant?.applicant_education,
          selfEmployment: res.data.applicant?.applicant_self_employment,
          unEmployment: res.data.applicant?.applicant_unemployment,
          applicantEmail: res.data.applicant?.email,
        });
      }
      this.setApiResponseIntoAddressProps(res.data.applicant?.applicant_address);
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
      this.missingRanges = res.data.missing_ranges || [];

      if (this.$refs.basicInfo !== undefined) {
        this.active = 0;
      } else if (this.$refs.addressInfo !== undefined) {
        this.active = 2;
        if (Array.isArray(res.data.missing_ranges) && res.data.missing_ranges.length) {
          this.$toastr.e('Missing address history. Please fill the gaps.');
          alert('Missing address history. Please fill the gaps.');
        }
      } else if (this.$refs.candidateHistory !== undefined) {
        if (Array.isArray(res.data.missing_ranges) && res.data.missing_ranges.length) {
          this.$toastr.e('Missing previous employment. Please fill the gaps.');
          alert('Missing previous employment. Please fill the gaps.');
        }
      } else if (this.$refs.applicantFiles !== undefined) {
        this.active = 6; // point to the Upload Documents step
        if (res.data.missing_documents && Array.isArray(res.data.missing_documents)) {
          this.missingDocuments = res.data.missing_documents;
          const missingList = res.data.missing_documents.join(', ');
          alert("Missing documents: " + missingList);
        }
      }

      this.shouldAdvanceStep = false; // ✅ always reset
    },

    afterFinalResponse() {
      this.preloader = false;
      this.registrationForm = {};
    },




  },
  computed: {
    aiDocumentUploadFields() {
      const cvAccept = '.pdf,.doc,.docx,.odt,.rtf,.txt';
      const documentAccept = '.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp';
      const fields = [
        {
          key: 'cv',
          label: 'CV',
          help: 'PDF, Word, OpenDocument, RTF or text. Max 10 MB.',
          accept: cvAccept,
          required: true,
        },
        {
          key: 'passport',
          label: 'Passport / Right-to-Work Proof',
          help: 'Passport photo page or right-to-work document.',
          accept: documentAccept,
          required: false,
        },
        {
          key: 'bankStatement',
          label: 'Bank Statement',
          help: 'Recent statement that clearly shows bank details.',
          accept: documentAccept,
          required: false,
        },
        {
          key: 'utilityBill_1',
          label: 'Utility Bill (A)',
          help: 'First proof of address.',
          accept: documentAccept,
          required: false,
        },
        {
          key: 'utilityBill_2',
          label: 'Utility Bill (B)',
          help: 'Second proof of address.',
          accept: documentAccept,
          required: false,
        },
        {
          key: 'siaLicense',
          label: 'SIA Licence',
          help: 'Front/back or a clear SIA portal screenshot.',
          accept: documentAccept,
          required: false,
        },
      ];

      if (this.aiHasDrivingLicense) {
        fields.push({
          key: 'driving_license',
          label: 'Driving Licence',
          help: 'Front and back, if available.',
          accept: documentAccept,
          required: false,
        });
      }

      return fields;
    },
    lastFormIndex(){
      return this.activeIdCollection.at(-1)
    },
    isMobile() {
      let width = window.innerWidth;
      let stepsDirection;
      // Set to vertical on small screens (less than 768px)
      if (width <= 768) {
        stepsDirection = 'vertical';
      } else {
        stepsDirection = 'horizontal';
      }
      return stepsDirection;
    }

  }
}
</script>

<style scoped>
.ai-cv-import {
  border: 1px solid #d9e5ff;
  background: #f8fbff;
  box-shadow: none;
}

.ai-cv-import .card-body {
  padding: 1rem 1.25rem;
}

.ai-cv-import .el-icon-magic-stick {
  color: #409eff;
}

.ai-cv-result {
  background: #ffffff;
}

.ai-cv-result ul {
  max-height: 120px;
  overflow-y: auto;
}

/* AI vs Manual choice modal */
.fill-choice-header h5 {
  color: #1f2d3d;
}

.fill-choice-options {
  margin-top: 0.25rem;
}

.fill-choice-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  padding: 1.75rem 1.25rem;
  border: 1px solid #d9e5ff;
  border-radius: 10px;
  background: #f8fbff;
  cursor: pointer;
  transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
}

.fill-choice-card:hover:not(:disabled) {
  border-color: #409eff;
  box-shadow: 0 6px 18px rgba(64, 158, 255, .18);
  transform: translateY(-2px);
}

.fill-choice-card:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.fill-choice-icon {
  font-size: 2.25rem;
  color: #409eff;
  margin-bottom: .75rem;
}

.fill-choice-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #1f2d3d;
  margin-bottom: .5rem;
}

.fill-choice-desc {
  font-size: .85rem;
  color: #6b7a90;
  line-height: 1.4;
}

.ai-consent-copy {
  color: #4b5563;
  line-height: 1.55;
}

.ai-consent-copy p:last-child {
  margin-bottom: 0;
}

.ai-driving-toggle {
  display: flex;
  align-items: center;
  gap: .5rem;
  margin-bottom: 1rem;
  font-size: .9rem;
  color: #1f2d3d;
}

.ai-document-list {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
}

.ai-document-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: .9rem 1rem;
  background: #ffffff;
  border-bottom: 1px solid #eef1f5;
}

.ai-document-row:last-child {
  border-bottom: 0;
}

.ai-document-meta {
  flex: 1 1 auto;
  min-width: 0;
}

.ai-document-meta strong,
.ai-document-meta span,
.ai-document-control small {
  display: block;
}

.ai-document-meta strong {
  color: #1f2d3d;
}

.ai-document-meta span {
  color: #6b7a90;
  font-size: .82rem;
  line-height: 1.35;
}

.ai-document-control {
  flex: 0 0 260px;
}

.ai-document-control input {
  width: 100%;
}

@media (max-width: 768px) {
  .ai-document-row {
    display: block;
  }

  .ai-document-control {
    margin-top: .75rem;
  }
}

.application-success-container {
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
}

.success-checkmark-wrapper {
  display: flex;
  justify-content: center;
}

.check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #4caf50;
}

.check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}

.check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}

.check-icon::before, .check-icon::after {
  content: '';
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}

.icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}

.icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}

.icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}

.icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgba(76, 175, 80, 0.5);
}

.icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes icon-line-tip {
  0% { width: 0; left: 1px; top: 19px; }
  54% { width: 0; left: 1px; top: 19px; }
  70% { width: 50px; left: -8px; top: 37px; }
  84% { width: 17px; left: 21px; top: 48px; }
  100% { width: 25px; left: 14px; top: 46px; }
}

@keyframes icon-line-long {
  0% { width: 0; right: 46px; top: 54px; }
  65% { width: 0; right: 46px; top: 54px; }
  84% { width: 55px; right: 0px; top: 35px; }
  100% { width: 47px; right: 8px; top: 38px; }
}

.animate-up {
  animation: fadeInUp 0.6s ease-out forwards;
  opacity: 0;
}

.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }
.delay-3 { animation-delay: 0.6s; }
.delay-4 { animation-delay: 0.8s; }
.delay-5 { animation-delay: 1s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bg-soft-success { background-color: rgba(40, 167, 69, 0.1); }
.bg-soft-primary { background-color: rgba(0, 123, 255, 0.1); }
.bg-soft-warning { background-color: rgba(255, 193, 7, 0.1); }

.step-icon-bg {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
}

.step-icon-bg i {
  font-size: 1.2rem;
}

.tracking-wider { letter-spacing: 0.05em; }
.lead-sm { font-size: 1.05rem; line-height: 1.6; }

.success-icon {
  animation: scale-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes scale-up {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding-top: 15px;
  padding-bottom: 10px;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.el-step.is-horizontal .el-step__main .el-step__title {
  padding-right: 14px !important;
  cursor: pointer;
}

.el-step__title {
  font-size: 12px !important;
  line-height: 40px !important;
  color: #292f4c !important;
}

.el-step__head.is-process .el-step__icon.is-text {
  color: #292f4c !important;
  border-color: #292f4c !important;
}

.el-step__head.is-finish {
  color: #292f4c !important;
  border-color: #292f4c !important;
}
.el-step__head.is-finish .el-step__line .el-step__line-inner {
  border-color: #292f4c !important;
}

.el-step__head.is-finish .el-step__icon.is-text {
  background-color: #292f4c !important;
  color: white !important;
  border-color: #C0C4CC !important;
}
.el-step__head.is-finish .el-step__icon .el-step__icon-inner::before {
  content: '\2713';
  font-size: 16px !important;
  font-weight: bold;
}

.el-step__head.is-finish .el-step__icon .el-step__icon-inner {
  content: "";
  font-size: 0;
}

@media (max-width: 768px) {
  .modal-dialog.modal-dialog-scrollable {
    height: 90vh;
  }
}
</style>

<!-- Not scoped: mandatory-field highlighting is applied (via JS) to inputs that
     are rendered inside child step components, which scoped styles cannot reach. -->
<style>
.ai-required-field-empty,
.ai-required-field-empty.form-control,
.ai-required-field-empty.custom-select,
.ai-required-field-empty .form-control,
.ai-required-field-empty .custom-select {
  border: 1px solid #f56c6c !important;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.15) !important;
}
</style>
